<template>
  <div>
    <div class="fixed-top">
      <nav
        class="navbar navbar-expand navbar-dark bg-dark justify-content-between"
      >
        <span class="navbar-brand">
          OneEd Testing System for Admins
        </span>
        <div>
          <button
            type="button"
            class="btn btn-outline-light mr-3"
            @click="copyAuth()"
          >
            Copy Auth
          </button>
          <button
            type="button"
            class="btn btn-outline-light"
            @click="localEventHandler('click-logout')"
          >
            Logout
          </button>
        </div>
      </nav>
      <nav class="navbar navbar-expand navbar-dark text-white bg-secondary">
        <button
          class="btn btn-sm btn-outline-light"
          @click="localEventHandler('click-batch-button')"
        >
          Batch {{ states.batchId }}
        </button>
        <ul class="navbar-nav ml-4">
          <li class="nav-item mx-2">
            <a
              :class="{
                'nav-link': true,
                clickable: true,
                active: this.$route.path == '/admin/tester'
              }"
              @click="localEventHandler('click-menu-tester')"
            >
              Testers
            </a>
          </li>
          <li class="nav-item mx-2">
            <a
              :class="{
                'nav-link': true,
                clickable: true,
                active: this.$route.path == '/admin/tester-stats'
              }"
              @click="localEventHandler('click-menu-tester-stats')"
            >
              Tester Stats
            </a>
          </li>
          <li class="nav-item mx-2">
            <a
              :class="{
                'nav-link': true,
                clickable: true,
                active: this.$route.path == '/admin/test'
              }"
              @click="localEventHandler('click-menu-test')"
            >
              Tests
            </a>
          </li>
          <li class="nav-item mx-2">
            <a
              :class="{
                'nav-link': true,
                clickable: true,
                active: this.$route.path == '/admin/report'
              }"
              @click="localEventHandler('click-menu-report')"
            >
              Reports
            </a>
          </li>
        </ul>
      </nav>
      <nav
        class="navbar navbar-expand navbar-light bg-light"
        v-if="$route.name == 'AdminReport' && states.isWindowLessLg"
      >
        <a class="badge" href="#div-issues"> Issues </a>
        <a class="badge" href="#div-q1"> Question(en) </a>
        <a class="badge" href="#div-q2"> Question(zh) </a>
      </nav>
      <nav
        class="navbar navbar-expand navbar-light bg-light"
        v-else-if="$route.name == 'AdminReport' && states.isWindowLessXl"
      >
        <a class="badge" href="#div-q1"> Question(en) </a>
        <a class="badge" href="#div-q2"> Question(zh) </a>
      </nav>
    </div>
    <div
      :class="{
        content: !states.isWindowLessXl,
        'content-less-xl': states.isWindowLessXl
      }"
    >
      <!-- modals -->
      <!-- modal: batches -->
      <modal
        id="batch-modal"
        title="Select batch"
        showBodyYScroll="true"
        bodyMaxHeight="50vh"
        size="md3"
      >
        <div class="container-fluid">
          <div class="row">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Description</th>
                  <th>
                    <small><b>Done/Assigned/Total Tests</b></small>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="b in batches"
                  :key="b.id"
                  :class="{
                    clickable: true,
                    'table-active': states.batchId == b.id
                  }"
                  @click="
                    localEventHandler('select-batch-list-item', { batch: b })
                  "
                >
                  <td>{{ b.id }}</td>
                  <td>{{ b.desc }}</td>
                  <td>
                    {{ b.numFinishedTest }} / {{ b.numAssignedTest }} /
                    {{ b.numTest }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </modal>
      <div>
        <router-view v-if="states.batchId" />
      </div>
    </div>
  </div>
</template>

<script>
import auth from '@/app/auth'
import api_admin from '@/api/api_admin'
import Modal from '@/components/Modal.vue'
export default {
  name: 'Admin',
  data () {
    return {
      batches: [],
      states: {
        batchId: 0,
        windowWidth: window.innerWidth,
        isWindowLessLg: window.innerWidth < 992,
        isWindowLessXl: window.innerWidth < 1200
      }
    }
  },
  components: {
    modal: Modal
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onWindowsResize)
      window.addEventListener('hashchange', this.onWindowHashChange)
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowsResize)
    window.removeEventListener('hashchange', this.onWindowHashChange)
  },
  created () {
    api_admin.get_batches().then(batches => {
      this.batches = batches ? batches : []
      this.batches.sort((a, b) => Number(b.id) - Number(a.id))
      if (!sessionStorage.batchId) {
        this.states.batchId = this.batches[0] ? this.batches[0].id : null
        sessionStorage.batchId = this.states.batchId
      } else {
        this.states.batchId =
          batches.map(x => x.id).indexOf(sessionStorage.batchId) >= 0
            ? sessionStorage.batchId
            : this.batches[0]
            ? this.batches[0].id
            : null
      }
    })
  },
  methods: {
    copyAuth () {
      navigator.clipboard.writeText(auth.auth.signInUserSession.getIdToken().jwtToken)
    },
    localEventHandler (name, event) {
      if (name == 'click-logout') {
        auth.logout()
      } else if (name == 'click-batch-button') {
        $('#batch-modal').modal('show')
      } else if (name == 'select-batch-list-item') {
        $('#batch-modal').modal('hide')
        sessionStorage.batchId = event.batch.id
        this.$router.go()
      } else if (name == 'click-menu-tester') {
        this.$router.push('/admin/tester')
      } else if (name == 'click-menu-tester-stats') {
        this.$router.push('/admin/tester-stats')
      } else if (name == 'click-menu-test') {
        this.$router.push('/admin/test')
      } else if (name == 'click-menu-report') {
        this.$router.push('/admin/report')
      } else if (name == 'window-resize') {
        this.states.windowWidth = window.innerWidth
        this.states.isWindowLessLg = window.innerWidth < 992
        this.states.isWindowLessXl = window.innerWidth < 1200
      } else if (name == 'window-hash-change') {
        window.scrollBy(0, -150)
      }
    },
    onWindowsResize () {
      this.localEventHandler('window-resize')
    },
    onWindowHashChange () {
      this.localEventHandler('window-hash-change')
    }
  }
}
</script>

<style scoped>
a {
  color: inherit; /* blue colors for links too */
  text-decoration: inherit; /* no underline */
}
.clickable {
  cursor: pointer;
}
.fixed-top {
  position: fixed;
  top: 0;
  width: 100%;
}
.content {
  padding-top: 120px;
}
.content-less-xl {
  margin-top: 150px;
}
</style>
